import { render, staticRenderFns } from "./DyProductsRank.vue?vue&type=template&id=6e9cbc48&scoped=true"
import script from "./DyProductsRank.vue?vue&type=script&lang=js"
export * from "./DyProductsRank.vue?vue&type=script&lang=js"
import style0 from "./DyProductsRank.vue?vue&type=style&index=0&id=6e9cbc48&prod&scoped=true&lang=scss"
import style1 from "./DyProductsRank.vue?vue&type=style&index=1&id=6e9cbc48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9cbc48",
  null
  
)

export default component.exports